import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { resolveEffectiveRole } from '../lib/roleUtils'

/**
 * ProtectedRoute - 인증된 사용자만 접근 가능한 라우트
 * @param {Object} props
 * @param {React.ReactElement} props.children - 보호할 컴포넌트
 * @param {string[]} props.allowedRoles - 허용된 사용자 유형 (선택사항)
 */
export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const { isAuthenticated, user } = useAuthStore()

  // 인증되지 않은 경우 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // 특정 역할만 허용하는 경우 권한 체크
  // staff → mold_developer 동일 취급 (auth.js + MobileProtectedRoute와 일관)
  // 2026-07-03: 겸업 협력사(plant+maker capabilities) 는 active_role 우선 판정.
  //   base user_type='plant' 인 겸업사가 제작처(active_role='maker')로 로그인 시
  //   user_type 기준이면 /dashboard/maker 차단 → '/' → active_role='maker' → 다시 /dashboard/maker
  //   → 리다이렉트 루프(Throttling navigation) + 빈 화면. active_role 우선으로 루프 차단.
  // 2026-07-08 (P3): 관리자(system_admin/mold_developer/staff)는 user_type 우선 —
  //   서버 middleware/auth.js:104 미러 (roleUtils SSoT). stale active_role 시 관리 라우트 차단 방지.
  //   협력사는 기존대로 active_role 우선 (겸업 루프 차단 유지).
  if (allowedRoles.length > 0 && user) {
    const effectiveRole = resolveEffectiveRole(user)
    if (!allowedRoles.includes(effectiveRole)) {
      // 권한이 없는 경우 대시보드로 리다이렉트
      return <Navigate to="/" replace />
    }
  }

  return children
}
